import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { PeopleInfoFormComponent } from "./peopleInfo-form.component";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { takeUntil } from "rxjs/operators";
@Component({
  selector: "peopleinfo-list",
  templateUrl: "peopleinfo-list.component.html",
  providers: [HttpCommonService],
})
export class PeopleInfoListComponent extends BaseListComponent {
  unSortableFilterable: string[] = [];
  actions: EntityListAction[];
  constructor(){
    super();
    this.setactions();
  }
  ngOnInit() {
    this.unSortableFilterable.push("Address");
    this.unSortableFilterable.push("Telephone");
    super.ngOnInit();
    this.inputEditorform = PeopleInfoFormComponent;
    this.apiName = "PeopleInfo";
    this.label = this.translate("ClientApp.GNR.PeopleInfo.IntroductionPersons");
    this.areaName = "General";
  }
  setactions() {
    this.actions = [
      {
        name: "rahkaranInfo",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.TaxPayerSystem.GetLatestInvoiceStatus"),
        iconName: "icon-content_copy-o",
        apiName: "Rahkaran/SendPeopleInfo",
        areaName: 'RestaurantSale',
        permission: Permission.viewPermission,
      },
    ];
  }
  onActionClick(){
    this.httpCommonService
      .getList("Rahkaran/SendPeopleInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          console.log(data);
        },
        (error) => console.log(error)
      );
  }
}
